interface LineaIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const LineaIcon: React.FC<LineaIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={colored ? '#121212' : 'currentColor'}>
        <path d="M17.6333 21H3.47754V5.92145H6.71639V18.0778H17.6333V21Z" />
        <path d="M17.6337 8.84141C19.2293 8.84141 20.5227 7.53375 20.5227 5.92069C20.5227 4.30764 19.2293 3 17.6337 3C16.0381 3 14.7446 4.30764 14.7446 5.92069C14.7446 7.53375 16.0381 8.84141 17.6337 8.84141Z" />
      </g>
    </svg>
  )
}
